// Single source of truth for Capacitor environment detection.
// The ONLY place in the codebase that references window.Capacitor directly.

export function isCapacitor(): boolean {
  return (
    typeof window !== "undefined" &&
    typeof (window as { Capacitor?: unknown }).Capacitor !== "undefined"
  )
}

export type Platform = "web" | "ios" | "android"

export function getPlatform(): Platform {
  if (!isCapacitor()) return "web"
  const cap = (window as unknown as { Capacitor: { getPlatform?: () => string } }).Capacitor
  const p = cap.getPlatform?.()
  if (p === "ios") return "ios"
  if (p === "android") return "android"
  return "web"
}
